import { useEffect, useState } from "react";
import { fetchNewspapers } from "../services/newspaperService";
import "../assets/css/blogs.css";
import { Link } from "react-router-dom";
import HeroSection from "../components/HeroSection";
import { fetchFeaturedNews } from "../services/FeaturedNewsService";
import Seo from "../components/Seo";


const BlogsOverview = ({ type, limit }) => {
    const [blogsData, setBlogsData] = useState([]);

    useEffect(() => {
        fetchFeaturedNews(type, limit)
            .then((response) => {
                console.log(response); // check API response
                setBlogsData(response.data); // adjust according to API
            })
            .catch((error) => {
                console.error("Error fetching news:", error);
            });
    }, [type, limit]);

    return (
        <div className="blogs-overview-container-wrapper blogs-overview-page">
            <Seo
                title="Blogs - Etawah Times"
                description="Etawah Times के ब्लॉग - Etawah और Uttar Pradesh की खबरों पर विश्लेषण, राय और फीचर स्टोरीज़।"
                canonical="/blogs"
            />
            {/* <HeroSection pageType="other" /> */}
            <div className="container py-5">
                <h3 className="text-lg-center">Blogs overview</h3>
                <div className="row">
                    {blogsData.map((blog) => (
                        <div className="col-lg-4 col-md-4 col-12 mb-3" key={blog.id}>
                            <div className="card">
                                <Link className="blogs-overview-div" to={`/blogs/${blog.slug}`}>
                                    <img src={blog.image_url} className="card-img-top" alt={blog.title} />
                                    <div className="card-body">
                                        <h5 className="mb-3">{blog.title}</h5>

                                        {blog.teaser_text && (
                                            <div
                                                className="news-teaser"
                                                dangerouslySetInnerHTML={{
                                                    __html: blog.teaser_text,
                                                }}
                                            ></div>
                                        )}

                                        <div className="d-flex justify-content-between">
                                            <p className="mb-0">{blog.publish_date}</p>
                                            <p className="mb-0">Read More</p>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );

};

export default BlogsOverview;
